import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';
import cx from 'clsx';
import consentStayInformedLottie from '@repo/visual-assets/dotlottie/lottie_vp_communication_gdpr_consent_desktop.lottie';
import styles from './value-proposition.module.css';

export interface ValuePropositionProps {
  className?: string;
}

export function ValueProposition({ className }: ValuePropositionProps): React.ReactElement {
  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.content}>
        <div className={styles.lottieContainer}>
          <LottiePlayer autoplay className={styles.lottie} loop src={consentStayInformedLottie} />
        </div>
      </div>
    </div>
  );
}
